export enum PaymentMethod {
  oxxo = "OXXO",
  codi = "CODI",
  bank = "BANK",
  spei = "SPEI",
  store = "OPENPAY",
  dealer = "DEALER",
  nequi = "NEQUI",
  bancolombia = "BANCOLOMBIA",
  pse = "PSE",
  efecty = "EFECTY",
  refacil = "REFACIL",
  movii = "MOVII",
}
